<template>
  <div class="record-item">
    <ul v-if="SafeItem">
        <li>ID：<a>{{ SafeItem.id }}</a></li>
        <li>名称：<a>{{ SafeItem.nickname }}</a></li>
        <li>代理比列：<a>{{ SafeItem.fanshuifee }}%&nbsp;<span style="
            text-align: center;
            color: #cbb788;
          "
          @click="parentToshow(0)">调整</span></a></li>
        <li v-if="SafeIsArea == 1">大区比列：<a v-if="SafeItem.region_authorization == 1">{{ SafeItem.region_fanshuifee }}%&nbsp;<span style="
            text-align: center;
            color: #cbb788;
          "
          @click="parentToshow(1)">调整</span></a>
          <a v-else><span style="
            text-align: center;
            color: #cbb788;
          "
          @click="parentToshow(1)">授权</span></a>
        </li>
        <li>团队人数：<a>{{ SafeItem.team_count }}</a></li>
        <li>今日流水：<a>{{ SafeItem.team_today_coded_vol }}</a></li>
        <li>今日盈亏：<a>{{ SafeItem.today_loss }}</a></li>
        <li>本月流水：<a>{{ SafeItem.month_bet_amount }}</a></li>
        <li style="border: none;">本月盈亏：<a>{{ SafeItem.month_loss }}</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name:'AgentInfView',
  props:['item','isArea'],
  computed:{
    SafeIsArea(){
      return this.isArea || 0
    },
    SafeItem(){
        return this.item || null
    }
  },
  methods:{
    parentToshow(type){
      this.$emit('change-zhekou',this.SafeItem,type)
    }
  }
}
</script>
<style lang="scss" scoped>
.record-item{
    width: calc(90% - 40px);
    margin: 14px auto 0;
    background: rgb(0, 0, 0,.65);
    border-radius: 10px;
    padding: 10px 20px;
    text-align: left;
    ul {
        width: 100%;
        font-size: 16px;
        li {
            position: relative;
            border-bottom: 1px solid #3e435d;
            line-height: 2;
            a {
                position: absolute;
                right: 0;
            }
        }
    }
}
</style>
